var notices = document.querySelectorAll('.js-notice');


function initNotice(notice) {
    var readMores = notice.querySelectorAll('.js-read-more')
    readMores.forEach(rm => {
        var btn = rm.nextElementSibling
        if (rm.dataset.clampLine) {
            var maxLines = parseInt(rm.dataset.clampLine)
            var lineHeight = parseFloat(rm.dataset.lineHeight)
            if (rm.offsetHeight > (maxLines * lineHeight * 16)) {
                btn.classList.add("tw:flex");
                btn.classList.remove("tw:hidden");
                rm.classList.add("tw:line-clamp-" + maxLines)
                btn.dataset.expanded = "false";
                var clampClass = undefined;
                btn.addEventListener("click", () => {
                    if (btn.dataset.expanded === "true") {
                        if (!!clampClass) {
                            rm.classList.add(clampClass);
                            btn.dataset.expanded = "false";
                            btn.querySelector("span").innerText = "Lire plus";
                        }
                    }
                    else {
                        rm.classList.forEach(c => {
                            if (c.startsWith("tw:line-clamp-")) {
                                clampClass = c;
                                rm.classList.remove(c);
                            }
                        });
                        btn.dataset.expanded = "true";
                        btn.querySelector("span").innerText = "Lire moins";
                    }
                });
            }
        }
    })

    var listSections = notice.querySelectorAll('.js-list-expand')
    listSections.forEach(cs => {
        var btn = cs.querySelector(":scope > .js-expand")
        if (btn) {
            var hiddenLines = cs.querySelectorAll(":scope > ul > li.tw\\:hidden")
            btn.addEventListener("click", () => {
                if (btn.dataset.expanded === "true") {
                    hiddenLines.forEach(hl => {
                        hl.classList.add("tw:hidden");
                    })
                    btn.dataset.expanded = "false";
                    btn.querySelector("span").innerText = "Voir plus";
                } else {
                    hiddenLines.forEach(hl => {
                        hl.classList.remove("tw:hidden")
                    })
                    btn.dataset.expanded = "true";
                    btn.querySelector("span").innerText = "Voir moins";
                }
            })
        }
    })

    var tabs = notice.querySelectorAll('.tabs button[role=tab]')
    tabs.forEach(t => {
        t.addEventListener('click', () => {
            setTimeout(
                () => {
                    var tabpanel = document.getElementById(t.getAttribute("aria-controls"))
                    if (tabpanel.querySelector(".js-img-gallery")) {
                        startSlider(tabpanel.querySelector(".js-img-gallery"))
                    } else if (tabpanel.querySelector(".js-gallery")) {
                        startSlider(tabpanel.querySelector(".js-gallery"))
                    }
                }, 10)
        })
    })

    var videoModalBtns = notice.querySelectorAll('.js-video-opener');
    var videoModal = notice.querySelector('.js-video-modal');
    var videoModalBg = document.querySelector('.js-overlay-bg');
    var videoModalTitle = document.getElementById('video-title');

    if (videoModal) {
        var videoCloseButton = videoModal.querySelector(".js-modal-close");
        var videoFakeCloseButton = videoModal.querySelector(".js-modal-close.hidden-btn");
        videoModalBtns.forEach(videoModalBtn => {

            function openDialog() {
                videoModal.querySelector('.js-video-body').innerHTML = `<video 
                    class="video-js tw:w-full tw:h-fit tw:aspect-[16/9]"
                    controls
                    controlslist="nodownload"
                    preload="auto"
                    data-setup="{}"
                    oncontextmenu="return false">
                    <source src="` + videoModalBtn.dataset.videoLink + `" type="video/mp4"/>
                </video>`;
                videoModalTitle.innerHTML = videoModalBtn.dataset.videoTitle + ' (Chargement en cours) <span aria-hidden="true" class="custom-loader custom-loader--white tw:inline-block"></span>';
                videoModal.classList.add('open');
                videoModal.focus();
                videoModal.addEventListener('keydown', handleKeyPress);
                videoModalBg.classList.add('show');
                var videoPlayer = videoModal.querySelector('video');
                videoPlayer.addEventListener('canplay', () => {
                    videoModalTitle.innerHTML = videoModalBtn.dataset.videoTitle;
                })
                videoPlayer.addEventListener('playing', () => {
                    videoModalTitle.innerHTML = videoModalBtn.dataset.videoTitle;
                })
            }

            function closeDialog() {
                videoModal.querySelector('.js-video-body').innerHTML = ''
                videoModalTitle.innerHTML = ''
                videoModal.classList.remove('open');
                videoModal.removeEventListener('keydown', handleKeyPress);
                videoModalBtn.focus();
                videoModalBg.classList.remove('show');
            }

            function handleKeyPress(event) {
                if (event.key === "Escape") {
                    closeDialog();
                } else if (event.key === "Tab") {
                    if (event.shiftKey) {
                        if (document.activeElement === videoCloseButton) {
                            event.preventDefault()
                            videoPlayer.focus()
                        }
                    } else {
                        if (document.activeElement === videoFakeCloseButton) {
                            videoPlayer.focus();
                        }
                    }
                }
            }

            if (!videoModalBtn.classList.contains('is-initialized')) {
                videoModalBtn.addEventListener("click", openDialog);
                videoModalBtn.classList.add('is-initialized');
            }

            videoCloseButton.addEventListener("click", closeDialog);
            videoFakeCloseButton.addEventListener("click", closeDialog);

            videoModalBg.addEventListener('click', () => {
                closeDialog()
            })
            videoModal.addEventListener("keydown", handleKeyPress);

        })
    }
}

if (notices.length > 0) {
    notices.forEach(notice => {

            var shareNotice = notice.querySelector(".js-share-notice")
            shareNotice.addEventListener("click", function () {
                var dropdown = document.getElementById("share-dropdown")
                if (shareNotice.getAttribute("aria-expanded") === "false") {
                    dropdown.classList.add("open")
                    shareNotice.setAttribute("aria-expanded", "true")
                } else {
                    dropdown.classList.remove("open")
                    shareNotice.setAttribute("aria-expanded", "false")
                }
            })

            var printNotice = notice.querySelector(".js-print-notice")
            printNotice.addEventListener("click", function () {
                window.print()
            })

            initNotice(notice)

            var popup = document.getElementById("popup-variant");
            if (popup) {
                var popupToggler = document.getElementById("popup-variant-toggle")
                popupToggler.addEventListener("click", function () {
                    popup.classList.add("open")
                    openOverlayBg();
                })

                var popupClose = popup.querySelector(".js-close-variant")
                popupClose.addEventListener("click", function () {
                    popup.classList.remove("open")
                    closeOverlayBg();
                })

                var accordionsVariant = popup.querySelectorAll(".accordion-variant")

                accordionsVariant.forEach(accordionVariant => {
                    var accordionButton = accordionVariant.querySelector(".accordion-variant-expand")
                    accordionButton.addEventListener("click", function () {
                        let accordionContent = accordionVariant.querySelector(".accordion-variant-content")
                        if (accordionButton.getAttribute("aria-expanded") === "false") {

                            accordionContent.classList.add("open")
                            accordionButton.setAttribute("aria-expanded", "true")

                            if (accordionVariant.dataset.loaded === "false") {

                                var variantID = accordionVariant.dataset.variantId;

                                const ajaxURL = "/o/notices-api/filmVariant?variantid=" + variantID

                                if (typeof Liferay !== 'undefined') {
                                    Liferay.Util.fetch(ajaxURL)
                                        .then(response => response.text())
                                        .then(html => {
                                            accordionContent.innerHTML = html;
                                            accordionVariant.dataset.loaded = "true";
                                            initNotice(accordionContent)
                                        })
                                        .catch(err => console.error(err));
                                }
                            }
                        } else {
                            accordionContent.classList.remove("open")
                            accordionButton.setAttribute("aria-expanded", "false")
                        }
                    });
                });
            }
        }
    )
}